module.exports = __webpack_public_path__ + "img/to-top-leave.21c086ea.svg";